$(document).ready(function() {
    initializeSearch();
	chatBotButtonClick();
	toggleFilters();
	closeSearchApp();
});

function initializeSearch() {
    updateSearchInput();
    submitSearch();
    clearFilters();
}


function updateSearchInput() {
	$(document).on('keyup', '#search-main-input', function() {
		$('.sf-field-search input.sf-input-text').val($(this).val());
	});
}

function submitSearch() {
	$(document).on('click', '#search-main-input-submit', function() {
		$('.searchandfilter').submit();
	}); 
}

function clearFilters() {
	$(document).on('click', '.remove-filter-button', function() {
		$('.search-filter-reset').click();
	});
}

function chatBotButtonClick() {
	$(document).on('click', '.search-chatbot', function() {
		window.location.href = `/search-bot?prompt=${$('.sf-field-search input.sf-input-text').val()}`;
	});
}

$(window).on('scroll', function() {
    const $sidebar = $('.side-bar-container');
    const $footer = $('.site-footer');
    if (!$sidebar.length || !$footer.length) return;

    const footerRect = $footer[0].getBoundingClientRect();
    const windowHeight = window.innerHeight;
    // Determine vh based on screen height
    console.log(windowHeight,'window height');
    let sidebarHeight = '125vh';
    if (windowHeight < 800) { // Small height
        sidebarHeight = '170vh';
    } else if(windowHeight < 700){
        sidebarHeight = '200vh';
    } else if (windowHeight < 1000) { // Medium height
        sidebarHeight = '135vh';
    }
    
    if (footerRect.top <= windowHeight) {
        const overlap = windowHeight - footerRect.top;
        $sidebar.css({
            'position': 'fixed',
            'bottom': `${overlap}px`,
            'top': 'auto',
            'height': sidebarHeight,
            'overflow-y': 'hidden'
        });
    } else {
        $sidebar.css({
            'position': 'fixed',
            'top': 'initial',
            'bottom': 'auto',
            'height': '100%',
            'overflow-y': 'auto'
        });
    }
});

function toggleFilters() {
	$(document).on('click', '#mobile-sidebar-options', function() {
		if ($('.side-bar-container').hasClass('active')) {
			$('.side-bar-container').removeClass('active search-app');
			$('body').removeClass('no-scroll');
		} else {
			$('.side-bar-container').addClass('active search-app');
            $('.side-bar-container').css('top',0);
            $('body').addClass('no-scroll');

		}
	});
}

function closeSearchApp() {
	$(document).on('click', '.search-app-close', function() {
		$('.side-bar-container').removeClass('active search-app');
		$('body').removeClass('no-scroll');
	});
}